<ng-container *transloco="let t">
  @if (showWarning()) {
    <ld-base-modal
      [title]="t('modalsSessionTimeoutTitle')"
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      [critical]="true"
      (closeModal)="onContinueSession()"
    >
      <div modal-content>
        <div class="flex justify-center">
          <img [src]="heroiconsWarning" alt="Warning" class="w-10 h-10" />
        </div>

        <p id="session-timeout-description" class="font-dm text-base text-ld-neutral-500 text-center">
          {{ t('modalsSessionTimeoutMessage') }}
        </p>

        <div class="flex flex-col items-center gap-2">
          <span class="font-dm text-sm text-ld-neutral-500">{{ t('modalsSessionTimeoutTimeRemaining') }}</span>
          <div id="session-timeout-countdown" class="font-dm text-4xl font-bold text-ld-error tabular-nums">
            {{ countDownFormatted() }}
          </div>
        </div>
      </div>

      <div modal-footer>
        <button id="session-timeout-logout-button" type="button" class="btn-outline-ld-purple" (click)="onLogoutNow()">
          {{ t('modalsSessionTimeoutLogoutButton') }}
        </button>
        <button
          id="session-timeout-continue-button"
          type="button"
          class="btn-primary-ld-purple"
          [disabled]="isRefreshing()"
          (click)="onContinueSession()"
        >
          @if (isRefreshing()) {
            <span class="inline-flex items-center gap-2">
              <span
                class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full"
              ></span>
              Refreshing...
            </span>
          } @else {
            {{ t('modalsSessionTimeoutContinueButton') }}
          }
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
